import MKTypography from 'components/MKTypography';
import gips_logo from 'assets/csdd_images/GIPS-Logo-3.jpg';
import prosupp_logo from 'assets/csdd_images/prosuppImage.jpeg';
import { Container, Grid } from '@mui/material';
import MKBox from 'components/MKBox';
import MKButton from 'components/MKButton';
import { Link } from 'react-router-dom';

const PartnersCompo = () => {
  return (
    <>
      <MKBox
        mt={15}
        pt={5}
        pb={5}
        mb={10}
        sx={{ backgroundColor: 'warning.main', px: { xs: 2 } }}
      >
        <Container>
          <MKTypography textGradient variant='h2' mb={8}>
            Our Partners
          </MKTypography>
        </Container>
        <Container
          sx={{
            backgroundColor: '#fff',
            borderRadius: 1,
            textAlign: 'center',
          }}
        >
          <Grid container justifyContent='center' sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
              <MKBox
                component='img'
                src={gips_logo}
                alt='Logo of GIPS partner'
                width='20%'
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MKBox
                component='img'
                src={prosupp_logo}
                alt='Logo of Prosupp consult partner'
                width='20%'
              />
            </Grid>
          </Grid>
        </Container>
        <Container sx={{ textAlign: 'center' }}>
          <MKButton
            variant='gradient'
            color='warning'
            component={Link}
            to='/contact-us'
            size='large'
          >
            work with us
          </MKButton>
        </Container>
      </MKBox>
    </>
  );
};
export default PartnersCompo;
